import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
  effect,
} from '@angular/core';
import { PatientSessionService } from '../patient-session.service';
import {
  PatientBehaviorDataModel,
  PatientBehaviorModel,
  PatientBehaviorType,
} from '../../../core/api/models';
import { BaseBoxComponent } from '../base-box/base-box.component';
import { ABCDataPanelComponent } from '../abc-data-panel/abc-data-panel.component';
import { Utils } from '../../../core/utils';

@Component({
  selector: 'app-box-behavior-intensity',
  templateUrl: './box-behavior-intensity.component.html',
  styleUrls: ['../data-entry-feedback.css'],
  standalone: false,
})
export class BoxBehaviorIntensityComponent extends BaseBoxComponent {
  @Input() text: string | null | undefined = '-';
  @Input() isTopBox: boolean = true;
  @Input() isBottomBox: boolean = false;
  @Input() behaviorID: number = 0;
  @Input() behavior: PatientBehaviorModel | undefined = undefined;
  @Input() isPreview?: boolean;

  behaviorData: PatientBehaviorDataModel[] = [];
  behaviorType: PatientBehaviorType = PatientBehaviorType.Intensity;
  lastIntensity: number | null = null;
  addingBehaviorData: boolean = false;
  lastRecordedIntensity: number | null = null;
  cooldownIntensity: number | null = null;

  @ViewChild('abcDataPanel') abcDataPanel!: ABCDataPanelComponent;

  constructor(
    protected override cdRef: ChangeDetectorRef,
    private patientSessionService: PatientSessionService
  ) {
    super(cdRef);
    this.isBehaviorBox = true;
    effect(() => {
      this.patientSessionService.dataChanged();
      const behaviorData = this.patientSessionService.getBehaviorData(
        this.behaviorID
      );
      if (behaviorData && behaviorData.length > 0) {
        this.behaviorData = behaviorData.filter((b) => !b.DeletedDate);
        this.behaviorData = this.behaviorData.filter(
          (value, index, self) =>
            index ===
            self.findIndex((t) => t.RecordedDate === value.RecordedDate)
        );
        const lastEntry = this.behaviorData[this.behaviorData.length - 1];
        this.lastIntensity = lastEntry?.IntValue ?? null;
      } else {
        this.behaviorData = [];
        this.lastIntensity = null;
      }
    });
  }

  get intensityOptions(): number[] {
    return Utils.intensityScaleValues(
      this.behavior?.IntensityScaleMin,
      this.behavior?.IntensityScaleMax,
      this.behavior?.IntensityScaleValues
    );
  }

  setExtraBoxes(): void {
    const dropdowns = document.querySelectorAll('.p-overlay.p-component');
    this.extraBoxes = Array.from(dropdowns).map(
      (dropdown) => new ElementRef(dropdown)
    );
    if (this.extraBox) {
      this.extraBoxes.push(this.extraBox);
    }
    if (this.extraBox2) {
      this.extraBoxes.push(this.extraBox2);
    }
  }

  override onClickOutside() {
    super.onClickOutside();
  }

  clickedBox(): void {
    if (this.extra2Opened) {
      return;
    }
    this.showExtra();
    this.setExtraBoxes();
  }

  override doLongPress(): void {
    this.showExtra2();
    this.abcDataPanel?.setLastEditingABCData();
    this.setExtraBoxes();
  }

  selectIntensity(intensity: number): void {
    if (this.addingBehaviorData) {
      return;
    }
    this.addingBehaviorData = true;
    this.cooldownIntensity = intensity;

    const recordedDate = new Date()
      .toISOString()
      .slice(0, 19)
      .replace('T', ' ');
    const dateToSave = new Date(recordedDate).fromUTCtoServerString();

    const isDateInTargetData = this.behaviorData.some(
      (t) => t.RecordedDate === dateToSave
    );
    if (isDateInTargetData) {
      this.addingBehaviorData = false;
      this.cooldownIntensity = null;
      return;
    }

    const behaviorData: PatientBehaviorDataModel = {
      TextValue: intensity.toString(),
      IntValue: intensity,
      PatientSessionID: 0,
      PatientBehaviorID: this.behaviorID,
      RecordedDate: dateToSave,
    };
    this.patientSessionService.addBehaviorData(behaviorData);
    this.lastRecordedIntensity = intensity;
    setTimeout(() => {
      this.lastRecordedIntensity = null;
    }, 220);
    setTimeout(() => {
      this.addingBehaviorData = false;
      this.cooldownIntensity = null;
    }, 1000);
  }

  intensityColor(intensity: number): string {
    const options = this.intensityOptions;
    if (options.length <= 1) {
      return '#e53935';
    }
    const index = options.indexOf(intensity);
    const ratio = index / (options.length - 1);
    const hue = 120 - ratio * 120;
    return `hsl(${hue}, 65%, 42%)`;
  }

}
